import { Tabs } from "antd";
import React from "react";
import styled from "styled-components";

const TabsStyle = styled(Tabs).withConfig({
  shouldForwardProp: (prop) => !['spaceItem', 'paddingLeft'].includes(prop),
})`
  .ant-tabs-nav {
    &::before {
      border-bottom: 2px solid #d9d9d9;
    }
  }

  .ant-tabs-nav-wrap {
    padding-left: ${(props) => props.paddingLeft || 0}px;
  }

  .ant-tabs-tab {
    padding-top: 0;
    padding-bottom: 8px;
    padding-left: ${(props) => props.spaceItem || 16}px;
    padding-right: ${(props) => props.spaceItem || 16}px;
    margin: 0px;
    font-weight: 400;
    font-size: 20px;
    line-height: 30px;
    letter-spacing: -0.96px;
    color: #000000;
    & > div {
      padding: 0 4px;
    }
    &-btn,
    &-remove {
      &:focus,
      &:active {
        color: #000000;
      }
    }
    &-active {
      .ant-tabs-tab-btn {
        color: #F12E11 !important;
        text-shadow: unset;
      }
    }
  }
  .ant-tabs-ink-bar {
    background: #F12E11;
  }
  &.v2 {
    .ant-tabs-nav {
      &::before {
        border-bottom: 3px solid #ffffff;
      }
    }
    .ant-tabs-tab {
      font-weight: 500;
      font-size: 20px;
      line-height: 34px;
      color: #616161;
      &-active {
        font-weight: 600;
      }
      @media (max-width: 1366px) {
        font-size: 20px;
      }
      @media (max-width: 1024px) {
        font-weight: 400;
        font-size: 16px;
        line-height: 20px;
        &-active {
          font-size: 18px;
          line-height: 20px;
        }
      }
    }
    .ant-tabs-ink-bar {
      height: 3px;
    }
  }
`;

const TabsCustomGift = (props) => {
  return <TabsStyle {...props} />;
};

export default TabsCustomGift;
